module.exports = __webpack_public_path__ + "img/post_component_arrow.3a80aec6.svg";